export default __webpack_public_path__ + "static/media/message_love.84581e69.webp";